/**
 * @fileoverview Regra pura do percurso de uma execução: o estado de cada nó no
 * desenho (passou, etapa atual, falhou). Fica fora do componente para ser
 * testada sem carregar o canvas.
 */

/** Estado de cada nó para o desenho: "completed", "running" (etapa atual), "error" ou nada. */
export const nodeStatusesOf = (execution) => {
  const statuses = {};
  const open = !execution.finishedAt;
  Object.entries(execution.nodeStates || {}).forEach(([nodeId, state]) => {
    // Nó que ficou "rodando" numa execução já encerrada passou: não há etapa atual.
    statuses[nodeId] = state.status === "running" && !open ? "completed" : state.status;
  });
  if (execution.currentNodeId && statuses[execution.currentNodeId] !== "error") {
    if (open && execution.status === "running") statuses[execution.currentNodeId] = "running";
    if (execution.status === "failed") statuses[execution.currentNodeId] = "error";
  }
  return statuses;
};
